export class PaginationObject {
    constructor(
        public currentPage?: number,
        public numPages?: number,
        public totalCount?: number,
        public pageSize?: number
    ) {}
}
